import styled from "styled-components";

export const FullHeight = styled.div`
  height: 100%;
`
